module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZmlsbD0iI0U4RThFOCIgZD0iTTExIDEwSDUuMzQ0TDExIDQuNDE0VjEweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/base/parts/tree/browser/expanded-dark.svg
// module id = 545
// module chunks = 0